import { NavLink } from "react-router-dom";

export default function NavbarDesktop({ links }) {
  return (
    <nav className="hidden lg:flex items-center gap-8">
      {links.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
          className={({ isActive }) =>
            `text-sm tracking-wide transition-colors ${
              isActive
                ? "text-[#2A1C14] font-semibold"
                : "text-[#5A3B31] hover:text-[#2A1C14]"
            }`
          }
          end={l.to === "/"}
        >
          {l.label}
        </NavLink>
      ))}
    </nav>
  );
}
